/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Comment_LabelInputs */

const en_markers_comment_label = /** @type {(inputs: Markers_Comment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment`)
};

const fr_markers_comment_label = /** @type {(inputs: Markers_Comment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commentaire`)
};

const de_markers_comment_label = /** @type {(inputs: Markers_Comment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentar`)
};

const it_markers_comment_label = /** @type {(inputs: Markers_Comment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commento`)
};

const ru_markers_comment_label = /** @type {(inputs: Markers_Comment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Комментарий`)
};

const es_markers_comment_label = /** @type {(inputs: Markers_Comment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comentario`)
};

const zh_cn2_markers_comment_label = /** @type {(inputs: Markers_Comment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`评论`)
};

const ja_markers_comment_label = /** @type {(inputs: Markers_Comment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コメント`)
};

const hi_markers_comment_label = /** @type {(inputs: Markers_Comment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टिप्पणी`)
};

const pt_pt2_markers_comment_label = /** @type {(inputs: Markers_Comment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comentário`)
};

/**
* | output |
* | --- |
* | "Comment" |
*
* @param {Markers_Comment_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_comment_label = /** @type {((inputs?: Markers_Comment_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Comment_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_comment_label(inputs)
	if (locale === "de") return de_markers_comment_label(inputs)
	if (locale === "it") return it_markers_comment_label(inputs)
	if (locale === "ru") return ru_markers_comment_label(inputs)
	if (locale === "es") return es_markers_comment_label(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_comment_label(inputs)
	if (locale === "ja") return ja_markers_comment_label(inputs)
	if (locale === "hi") return hi_markers_comment_label(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_comment_label(inputs)
	return en_markers_comment_label(inputs)
});